module.exports = __webpack_public_path__ + "img/dehsen.com-user__research.2dc389f8.jpg";